module.exports = __webpack_public_path__ + "img/img_competizioni.8657b568.png";